const videoBlobsCache = {};

export function setVideoBlob(id, blob) {
  if (id && blob) {
    videoBlobsCache[id] = blob;
  }
}

export function getVideoBlob(id) {
  if (!id) return null;
  return videoBlobsCache[id] || null;
}

export function removeVideoBlob(id) {
  if (id) {
    delete videoBlobsCache[id];
  }
}

export default {
  setVideoBlob,
  getVideoBlob,
  removeVideoBlob,
};
